import {
  faBath,
  faBed,
  faLocationDot,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { slugify } from '../../utils/slugify';

export default function UpcomingProperties() {
  const [data, setData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    async function getData() {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/properties?status=offPlan`
        );
        setData([res.data[0], res.data[1], res.data[2]]);
      } catch (err) {
        console.log(err);
      }
    }
    getData();
  }, []);

  return (
    <div className="mb-8 text-left mx-[3vw] sm:mx-[10vw]">
      <div className="grid items-center justify-between grid-cols-1 mb-6 md:grid-cols-3">
        <h1
          className="md:col-span-2 text-2xl font-bold text-[#1a1a1d] text-left  sm:text-4xl md:text-4xl  font-poppins"
          style={{ color: "#173d73" }}
        >
          Upcoming Properties
        </h1>
        <button
          className="rounded-[8px] mt-2    bg-[#173D73] hover:bg-[#DE241A] text-white py-2 px-12  border \
    hover:text-white transition-all duration-500"
          onClick={() => {
            window.scrollTo(0, 0);
            navigate("/upcoming-properties");
          }}
        >
          Show All Properties
        </button>
      </div>
      <section className="box-border p-2">
        <div className="flex flex-wrap items-center justify-center gap-3">
          {data.map((property, i) => {
            return (
              <div
                key={i}
                className="h-[400px] w-full md:w-[23.5vw]  bg-white border flex flex-col rounded-lg overflow-hidden cursor-pointer"
                onClick={() => {
                  navigate(`/property/${slugify(property.name)}`);
                }}
              >
                <div className="h-[250px] overflow-hidden">
                  <img
                    className="object-cover w-full h-full"
                    src={property.images[0]}
                    alt=""
                  />
                </div>
                <div className="flex flex-col p-4">
                  <p className=" font-poppins text-xl mb-1 text-[#1a1a1d] font-semibold">
                    {property.name}
                  </p>
                  <p className="text-gray-500 text-md font-poppins">
                    <FontAwesomeIcon icon={faLocationDot} /> {property.location}
                  </p>
                  <p className="border border-[#173d73] rounded-lg py-1 mt-5 flex justify-center items-center text-[#173d73] hover:bg-[#173d73] hover:text-white transition-all duration-500 cursor-pointer font-poppins text-[1rem]">
                    Explore
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </section>
      {/* <button
        className="rounded-[4px] mt-2 transition-all duration-200 bg-white cursor-pointer text-black py-2 px-4 font-bold hover:text-white hover:bg-black"
        onClick={() => {
          window.scrollTo(0, 0);
          navigate('/upcoming-properties');
        }}
      >
        See More &rarr;
      </button> */}
    </div>
  );
}
